import { createSlice } from "@reduxjs/toolkit";

const initialState = { isOpen: false, severity: "", message: "" };

const showAlertSlice = createSlice({
    name: "showAlert",
    initialState,
    reducers: {
        showAlertPopup: (state, action) => {
            const { isOpen, severity, message } = action.payload || {};
            return { ...state, isOpen, severity, message };
        },

        hideAlertPopup: (state, action) => {
            const { isOpen, severity, message } = action.payload || {};
            return { ...state, isOpen, severity, message };
        }
    }
});

export const { showAlertPopup, hideAlertPopup } = showAlertSlice.actions;

export default showAlertSlice.reducer;
